import { z } from "zod";
export const TokenDataAliasSchema = z.object({
    aliasTo: z
        .string()
        .optional()
        .nullable()
        .transform((v) => v !== null && v !== void 0 ? v : undefined),
});
export function tokenAliasOrValue(value) {
    return TokenDataAliasSchema.extend({
        value: value
            .optional()
            .nullable()
            .transform((v) => (v !== null && v !== void 0 ? v : undefined)),
    });
}
